module.exports = __webpack_public_path__ + "static/pattern-widget-form-961c80ff0f058c777b71380aa07dc801.png";